import axios from 'axios'

// create an axios instance
const service = axios.create({
  baseURL: 'http://mlxc.tenzont.com/h5/web', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 * 2 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.header.rspcode !== '00') {
      return Promise.reject(new Error(res.header.rspmsg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error)
    console.log(error.message)
    return Promise.reject(error)
  }
)

export default service
